export default __webpack_public_path__ + "static/media/bannerA.a9478767.webp";